<template>
    <div class="container fondo">
        <img src="../assets/bg/pre3.jpg" alt="" class="bg">
        <img src="../assets/bg/pre3-celular.jpg" alt="" class="bgcel">
        <div class="contbut">
            
        </div>
    </div>  
    <div class="container contpre">
        <div class="col-lg-7 divpre3">
            <Control 
                p="Mientras te cepillas los dientes es recomendable… "
                estilo="pregunta3"
                link="p4"
                r1="Abrir la llave duro para que no te escuchen cuando escupes."
                r2="Cerrar la llave para no malgastar el agua."
                r3="Usar agua caliente para que no se te destemplen los dientes."
                real = "b"
            
            />
        </div>
    </div>
    
</template>

<script>
import Control from "@/components/Control";
import Fondos from '@/components/Fondos.vue'
export default {
    components:{
        Control,
        Fondos
    }
}
</script>


